import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { Authenticity } from './pages/Authenticity';
import { CrewRewards } from './pages/CrewRewards';
import { Activate } from './pages/Activate';
import { ScrollToHash } from './components/ScrollToHash';
import { initPixels } from './utils/tracking';
type OfferId = 'single' | 'trio' | 'crew';
interface AppProps {
  showAnnouncementBar?: boolean;
  defaultOffer?: OfferId;
}
export function App({
  showAnnouncementBar = true,
  defaultOffer = 'trio'
}: AppProps) {
  // Loads the Meta Pixel once and fires PageView as soon as the site loads, on any page.
  useEffect(() => {
    initPixels();
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="2wi5nzkmk8rqd">
      <ScrollToHash data-id="element-1" data-mp="28u5zkrcq1dey" />
      <Routes data-id="element-2" data-mp="28tmej1rry8wp">
        <Route path="/" element={<Home showAnnouncementBar={showAnnouncementBar} defaultOffer={defaultOffer} data-id="element-4" data-mp="28s31dk1f0dz5" />} data-id="element-3" data-mp="28t4kmbsl46ry" />
        <Route path="/verify" element={<Authenticity data-id="element-6" data-mp="3ikh5q2ysagvt" />} data-id="element-5" data-mp="23ti5txx3yih1" />
        <Route path="/rewards" element={<CrewRewards data-id="element-8" data-mp="3ii4t85bsoyq5" />} data-id="element-7" data-mp="3ij61y35c994p" />
        <Route path="/activate" element={<Activate data-id="element-10" data-mp="3mk8710lxsfel" />} data-id="element-9" data-mp="3mlat8v8bdto6" />
        <Route path="/legal/:slug" element={<Legal data-id="element-12" data-mp="3rcj6y3gog175" />} data-id="element-11" data-mp="3mjq3rk0ux0x6" />
        <Route path="*" element={<Legal data-id="element-14" data-mp="3rdkkqfp2v1sk" />} data-id="element-13" data-mp="3rbzomln47asl" />
      </Routes>
    </BrowserRouter>;
}